import React from 'react'
import GroupApp from '../../features/group/Group'
export default function Group() {
  return (<GroupApp/>)
}
